import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/services/virtual-makeup-snapchat"
    exact
    path="/business/services/virtual-makeup-snapchat"
    component={AsyncPage}
  />,
];
